import { ApiFilters, FilterItem } from "./types";

export const parseAPIFilters = (apiFilters: ApiFilters): FilterItem[] => {
    if (apiFilters!=null)
    {
        return apiFilters.items;
    }
    else 
        return []
}
